function attachProductClickListener() {
    const products = document.querySelector(".product-variant-picker-color");
    if (products) {
        products.addEventListener("click", handleClick);
    }
}

function getSectionsToRender(limit = 10) {
    const sectionsWrapper = document.getElementById('MainContent');
    if (!sectionsWrapper) return [];

    return [...sectionsWrapper.querySelectorAll('.shopify-section')]
        .slice(0, limit)
        .map(section => ({
            id: section.id,
            section: section.id.replace('shopify-section-', ''),
            selector: '#'+section.id
        }));
}

function getSectionInnerHTML(html, selector) {
    const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
    const element = parsedDocument.querySelector(selector);
    return element ? element.innerHTML : '';
}

// ✅ **Load third-party scripts properly**
function executeScriptsFromHTML(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const scripts = doc.querySelectorAll("script");

    scripts.forEach(script => {
        if (script.src) {
            // ✅ Load external scripts only if not already present
            if (!document.querySelector(`script[src="${script.src}"]`)) {
                const newScript = document.createElement("script");
                newScript.src = script.src;
                newScript.async = true;
                document.body.appendChild(newScript);
            }
        } else if (script.textContent.trim()) {
            // ✅ Ignore scripts containing JSON data (heuristic: checks for '{' at the start)
            const scriptContent = script.textContent.trim();
            if (!scriptContent.startsWith('{') && !scriptContent.startsWith('[')) {
                try {
                    const inlineScript = document.createElement("script");
                    inlineScript.textContent = scriptContent;
                    document.body.appendChild(inlineScript);
                } catch (error) {
                    console.error("Error executing inline script:", error, scriptContent);
                }
            }
        }
    });
}

function reloadScriptsFromDomain(domain) {
    // Find all existing scripts from the domain
    const scriptsToReload = [...document.querySelectorAll(`script[src^="${domain}"]`)]
        .map(script => script.src);

    // Remove existing scripts
    scriptsToReload.forEach(src => {
        document.querySelector(`script[src="${src}"]`)?.remove();
    });

    // Reload scripts dynamically
    scriptsToReload.forEach(src => {
        const newScript = document.createElement("script");
        newScript.src = src;
        newScript.async = true;
        newScript.onload = () => { 
          //add code here
          //console.log(`Reloaded script: ${src}`); 
        }
        document.body.appendChild(newScript);
    });
}

function handleResponse(request, sections, newUrl) {
    const res = JSON.parse(request.responseText);
    //console.log(res);

    sections.forEach(section => {
        const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) ||
            document.getElementById(section.id);

        if (elementToReplace) {
            elementToReplace.innerHTML = getSectionInnerHTML(res[section.section], section.selector);
            executeScriptsFromHTML(res[section.section]); // ✅ Reinitialize inline scripts
        }
    });

    // ✅ Update browser URL only once
    if (window.location.href !== newUrl) {
        window.history.replaceState(null, '', newUrl);
    }

    // ✅ Reattach product click listener after updating content
    attachProductClickListener();

    // ✅ Reload all scripts from Okendo's domain dynamically
    reloadScriptsFromDomain("https://d3hw6dc1ow8pp2.cloudfront.net");
}


// ✅ Load sections in batches of 5 (if more than 10 exist)
function fetchSections(url, sections, delay = 0) {
    setTimeout(() => {
        const request = new XMLHttpRequest();
        request.addEventListener('load', function () {
            handleResponse(request, sections, url);
        });

        const sectionParams = sections.map(section => section.section).join(',');
        request.open('GET', `${url}?sections=${sectionParams}`, true);
        request.send();
    }, delay);
}

function handleClick(event) {
    const anchor = event.target.closest("a[href]");
    if (!anchor) return;
    event.preventDefault();

    const url = anchor.getAttribute("href");
    const productID = anchor.getAttribute("data-product-id");
    const productCat = event.target.closest("[data-product-cat]").getAttribute("data-product-cat");
    const customerEmail = event.target.closest("[data-customer-email]").getAttribute("data-customer-email");

    // ✅ Fire Scarab event only once per click
    if (!window._scarabEventTriggered) {
        window._scarabEventTriggered = true;
        window.ScarabQueue = window.ScarabQueue || [];
        ScarabQueue.push(['view', `${productID}`]);
        ScarabQueue.push(['category', `${productCat}`]);
        ScarabQueue.push(['displayCurrency', window.Shopify.currency.active]);
        if(customerEmail != ''){
          ScarabQueue.push(['setEmail', `${customerEmail}`]);
        }
        if(window.cartItems != undefined){
          ScarabQueue.push(['cart', window.cartItems]);
        }else{
          ScarabQueue.push(['cart', []]); 
        }
        ScarabQueue.push(['go']);
        //console.log('ScarabQueue Triggered:', window.ScarabQueue);
        
        // Reset flag after a delay to allow new clicks
        setTimeout(() => { window._scarabEventTriggered = false; }, 100);
    }
    
    const allSections = getSectionsToRender(20);
  
    // remove existing product modal
    document.querySelectorAll("product-modal").forEach(el => el.remove());
    // ✅ Process sections in batches of 5
    for (let i = 0; i < allSections.length; i += 5) {
        fetchSections(url, allSections.slice(i, i + 5), i * 300);
    }
}

// ✅ Initial attach
attachProductClickListener();
